<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
export default {
  name: 'UserDetailsRecruiterForm',
  props: {
    validation: Object
  },
  data () {
    return { 
      selectedManager: null
    }
  },
  computed: {
    ...mapState('users', {
      recruiterForm: state => state.recruiterForm,
      canEdit: state => state.userModal.canEdit,
      isUserWizard: state => state.userWizardModal.open
    }),
    ...mapGetters('users', [
      'managerOptions',
      'affiliateOptions'
    ]),
    affiliateIds () {
      return this.recruiterForm.AFFILIATES.map(affiliate => affiliate.AFFILIATE_ID)
    }
  },
  methods: {
    ...mapMutations('users', [
      'updateRecruiterForm'
    ]),
    ...mapMutations([
      'closeDetails'
    ])
  }
}
</script>

<template>
  <div>
    <div class="row">
      <!-- <q-field 
        class="q-pa-md col-4"
        error-label="Manager is required"
        :error="validation.recruiterForm.MANAGER_ID.$error">
       <q-select
        float-label="Manager"
        :after="[
          {icon: 'flag', color: 'red', class: 'exclamation-circle-icon', condition: validation.recruiterForm.MANAGER_ID.$invalid},
          {icon: 'fa fa-check', condition: !validation.recruiterForm.MANAGER_ID.$invalid}
        ]"
        @blur="validation.recruiterForm.MANAGER_ID.$touch"
        v-model="recruiterForm.MANAGER_ID"
        :options="managerOptions"
        filter autofocus-filter
        :disable="!canEdit"
        clearable
        />
      </q-field> -->
      <!-- <q-field 
        class="q-pa-md col-4"
        error-label=" is required"
        :error="validation.recruiterForm.RECRUITER_CODE.$error">
        <q-select
          chips
          multiple
          float-label="Associated Affiliates"
          :value="affiliateIds"
          :options="affiliateOptions"
           filter autofocus-filter
          @input="affiliateIds => this.updateRecruiterForm({ 
            field: 'AFFILIATES', 
            value: affiliateIds.map(affiliateId => { 
              return { AFFILIATE_ID: affiliateId } 
            })
          })"
        />
      </q-field> -->
       <q-field class="q-pa-md col-4"
        error-label="Recruiter code is required"
        :error="validation.recruiterForm.RECRUITER_CODE.$error">
        <q-input
          float-label="Recruiter Code"
          :value="recruiterForm.RECRUITER_CODE"
          :after="[
            {icon: 'flag', color: 'red', class: 'exclamation-circle-icon', condition: validation.recruiterForm.RECRUITER_CODE.$invalid, handler () {}},
            {icon: 'fa fa-check', condition: !validation.recruiterForm.RECRUITER_CODE.$invalid}
          ]"
          @blur="validation.recruiterForm.RECRUITER_CODE.$touch"
          @keyup.stop="updateRecruiterForm({ field: 'RECRUITER_CODE', value: $event.target.value })"
          :disable="!canEdit"
          required>
        </q-input>
      </q-field>
    </div>
   
  </div>
</template>

<style>
.exclamation-circle-icon {
  font-size:1.4rem !important
}
</style>
